/* Maison Ronron v13 bis « ultime » : coque (préfixe m).
   Barre de navigation en verre (indicateur de section, rétraction au défilement), barre de lecture,
   VRAI panier Shopify (/cart/add.js, /cart.js, /cart/change.js) avec la goutte, la gelée, le tiroir en verre,
   barre d'achat flottante, carte finale (halo, titre, parallaxe). Chargé par snippets/mr14-calques.liquid.
   API : window.MR14.panier = { ajouter(bouton), ouvrir(), fermer(), lire() }. */
(function () {
  'use strict';

  const MR14 = window.MR14 = window.MR14 || {};
  const racineUrl = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/?$/, '/');
  const URL_AJOUT = racineUrl + 'cart/add.js';
  const URL_PANIER = racineUrl + 'cart.js';
  const URL_CHANGE = racineUrl + 'cart/change.js';
  const IDS = ['produit', 'atouts', 'installation', 'avis', 'faq'];
  const ETATS = ['appui', 'vole', 'pose', 'fini'];
  const ERREUR_DEFAUT = 'Impossible d’ajouter ce hamac au panier pour le moment. Réessayez dans un instant.';

  MR14.pret(() => {
    const reduit = !!MR14.reduit || document.documentElement.classList.contains('reduit');
    const $ = (s) => document.querySelector(s);
    const $$ = (s) => [...document.querySelectorAll(s)];

    const nav = $('[data-m-nav]');
    const progres = $('[data-m-progres]');
    const indic = $('[data-m-indic]');
    const liens = {};
    $$('[data-m-lien]').forEach((a) => { liens[a.dataset.mLien] = a; });
    const panierBtn = $('[data-m-panier]');
    const pastille = $('[data-m-pastille]');
    const compteEl = $('[data-m-compte]');
    const goutte = $('[data-m-goutte]');
    const s1 = $('[data-m-s1]');
    const s2 = $('[data-m-s2]');
    const s3 = $('[data-m-s3]');
    const eclat = $('[data-m-eclat]');
    const voile = $('[data-m-voile]');
    const tiroir = $('[data-m-tiroir]');
    const fermerBtn = $('[data-m-fermer]');
    const articlesEl = $('[data-m-articles]');
    const pleinEl = $('[data-m-plein]');
    const videEl = $('[data-m-vide]');
    const lignesEl = $('[data-m-lignes]');
    const totalEl = $('[data-m-total]');
    const erreurEl = $('[data-m-erreur]');
    const annonceEl = $('[data-m-annonce]');
    const mini = document.getElementById('mr14-mini');
    const barre = $('[data-m-barre]');
    const final = $('[data-m-final]');

    /* ===================== Défilement : barre de lecture, rétraction, parallaxe finale ===================== */
    let compact = null;
    MR14.auDefilement(() => {
      const y = window.scrollY || 0;
      const H = document.documentElement.scrollHeight - window.innerHeight;
      if (progres) progres.style.setProperty('--m-p', H > 0 ? Math.min(1, Math.max(0, y / H)).toFixed(4) : '0');
      const c = y > 24;
      if (nav && c !== compact) { compact = c; nav.classList.toggle('m-compact', c); }
      if (final && !reduit) {
        const r = final.getBoundingClientRect();
        const vh = window.innerHeight;
        if (r.top < vh && r.bottom > 0) {
          const p = (vh - r.top) / (vh + r.height);
          final.style.setProperty('--m-pf', ((0.5 - p) * 90).toFixed(1) + 'px');
        }
      }
    });

    /* ===================== Indicateur de section qui glisse ===================== */
    let section = '';
    const placerIndic = (id) => {
      if (!indic) return;
      const el = liens[id];
      if (!el) { indic.style.setProperty('--m-o', '0'); return; }
      indic.style.setProperty('--m-x', el.offsetLeft + 'px');
      indic.style.setProperty('--m-w', el.offsetWidth + 'px');
      indic.style.setProperty('--m-o', '1');
    };
    const marquer = (id) => {
      Object.keys(liens).forEach((k) => {
        liens[k].classList.toggle('m-actif', k === id);
        if (k === id) liens[k].setAttribute('aria-current', 'true'); else liens[k].removeAttribute('aria-current');
      });
    };
    placerIndic('produit');
    if (indic) indic.style.setProperty('--m-o', '0');
    addEventListener('resize', () => placerIndic(section), { passive: true });

    if ('IntersectionObserver' in window) {
      const vis = new Set();
      const obsS = new IntersectionObserver((entrees) => {
        entrees.forEach((e) => { if (e.isIntersecting) vis.add(e.target.id); else vis.delete(e.target.id); });
        const actif = IDS.find((id) => vis.has(id)) || '';
        if (actif !== section) { section = actif; marquer(actif); placerIndic(actif); }
      }, { rootMargin: '-42% 0px -52% 0px' });
      IDS.forEach((id) => { const el = document.getElementById(id); if (el) obsS.observe(el); });
    }

    /* ===================== Barre d'achat flottante ===================== */
    let horsFiche = false;
    let dansFinal = false;
    let barreVue = false;
    const majBarre = () => {
      const v = horsFiche && !dansFinal;
      if (!barre || v === barreVue) return;
      barreVue = v;
      barre.classList.toggle('m-vue', v);
      barre.setAttribute('aria-hidden', v ? 'false' : 'true');
      barre.inert = !v;
    };
    if (barre) barre.inert = true;
    const achat = $('[data-mr14-achat]');
    if ('IntersectionObserver' in window) {
      if (achat && barre) {
        new IntersectionObserver((entrees) => {
          entrees.forEach((e) => { horsFiche = !e.isIntersecting && e.boundingClientRect.top < 0; });
          majBarre();
        }).observe(achat);
      }
      if (final) {
        new IntersectionObserver((entrees) => {
          entrees.forEach((e) => { dansFinal = e.isIntersecting || e.boundingClientRect.top < 0; });
          majBarre();
        }).observe(final);
        // le halo se lève et le titre se révèle, une seule fois
        if (reduit) final.classList.add('m-leve');
        else {
          const obsL = new IntersectionObserver((entrees) => {
            entrees.forEach((e) => { if (e.isIntersecting) { final.classList.add('m-leve'); obsL.disconnect(); } });
          }, { threshold: 0.22 });
          obsL.observe(final);
        }
      }
    } else if (final) {
      final.classList.add('m-leve');
    }

    /* ===================== Outils ===================== */
    let tic = 0;
    let pop = 0;
    // Chiffre qui roule : vers le haut (sens > 0) ou vers le bas
    const roule = (el, valeur, sens) => {
      if (!el) return;
      valeur = String(valeur);
      if (el.textContent === valeur) return;
      el.textContent = valeur;
      tic += 1;
      el.classList.remove('m-rh1', 'm-rh2', 'm-rb1', 'm-rb2');
      el.classList.add((sens < 0 ? 'm-rb' : 'm-rh') + (tic % 2 ? '1' : '2'));
    };
    const annoncer = (t) => { if (annonceEl) { annonceEl.textContent = ''; setTimeout(() => { annonceEl.textContent = t; }, 30); } };
    const articles = (n) => (n === 0 ? 'Aucun article' : n + (n > 1 ? ' articles' : ' article'));
    const normal = (t) => String(t || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    const json = (url, corps) => fetch(url, corps ? {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(corps),
    } : { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then((r) => r.json().catch(() => ({})).then((d) => {
      if (!r.ok || (d && d.status && Number(d.status) >= 400)) {
        const err = new Error((d && (d.description || d.message)) || ERREUR_DEFAUT);
        err.donnees = d;
        throw err;
      }
      return d;
    }));

    let minuteurErreur = 0;
    const montrerErreur = (texte) => {
      if (!erreurEl) return;
      clearTimeout(minuteurErreur);
      erreurEl.textContent = texte || ERREUR_DEFAUT;
      erreurEl.hidden = false;
      requestAnimationFrame(() => erreurEl.classList.add('m-vu'));
      minuteurErreur = setTimeout(cacherErreur, 9000);
    };
    function cacherErreur() {
      if (!erreurEl || erreurEl.hidden) return;
      clearTimeout(minuteurErreur);
      erreurEl.classList.remove('m-vu');
      setTimeout(() => { if (!erreurEl.classList.contains('m-vu')) erreurEl.hidden = true; }, reduit ? 0 : 320);
    }

    /* ===================== Boutons d'ajout selon le coloris ===================== */
    const libelle = (btn, texte) => {
      const a = btn.querySelector('.m-btn-a');
      if (!a) return;
      let n = [...a.childNodes].find((x) => x.nodeType === 3 && x.data.trim());
      if (!n) { n = document.createTextNode(''); a.insertBefore(n, a.firstChild); }
      if (n.data !== texte) n.data = texte;
    };
    const majBoutons = () => {
      const v = typeof MR14.variante === 'function' ? MR14.variante() : null;
      $$('[data-mr14-ajouter]').forEach((b) => {
        if (b.classList.contains('appui') || b.classList.contains('vole') || b.classList.contains('pose') || b.classList.contains('fini')) return;
        b.disabled = !v;
        libelle(b, v ? 'Ajouter au panier' : 'Bientôt disponible');
      });
      $$('[data-mr14-id]').forEach((i) => { i.value = v || ''; });
      const info = typeof MR14.info === 'function' ? MR14.info() : null;
      if (info && info.prix != null) $$('[data-m-prix]').forEach((e) => { e.textContent = MR14.prix(info.prix); });
      if (info) $$('.m-final-img[role="img"]').forEach((s) => s.setAttribute('aria-label', 'Illustration du hamac de fenêtre, coloris ' + info.nom));
    };
    if (typeof MR14.surColoris === 'function') MR14.surColoris(majBoutons);
    majBoutons();

    /* ===================== Rendu du tiroir depuis /cart.js ===================== */
    let compte = Number(compteEl ? compteEl.textContent : 0) || 0;
    let qtes = {};

    const colorisLigne = (item) => {
      const liste = (MR14.donnees && MR14.donnees.coloris) || [];
      const parId = liste.find((c) => c.variante && Number(c.variante) === Number(item.variant_id));
      if (parId) return parId;
      const vals = (item.options_with_values || []).map((o) => o.value);
      if (item.variant_title) vals.push(...String(item.variant_title).split(' / '));
      for (const v of vals) {
        const c = liste.find((x) => x.id === normal(v));
        if (c) return c;
      }
      return null;
    };

    const poserCompte = (n, sens) => {
      const avant = compte;
      compte = n;
      roule(compteEl, n, sens);
      if (pastille) {
        pastille.classList.toggle('m-on', n > 0);
        if (n > 0 && n !== avant) {
          pop += 1;
          pastille.classList.remove('m-pop1', 'm-pop2');
          pastille.classList.add(pop % 2 ? 'm-pop1' : 'm-pop2');
        }
      }
      if (panierBtn) panierBtn.setAttribute('aria-label', n ? `Ouvrir le panier, ${n} article${n > 1 ? 's' : ''}` : 'Ouvrir le panier');
      if (articlesEl) articlesEl.textContent = articles(n);
      if (pleinEl) pleinEl.hidden = n === 0;
      if (videEl) videEl.hidden = n !== 0;
    };

    const icone = (d) => {
      const ns = 'http://www.w3.org/2000/svg';
      const svg = document.createElementNS(ns, 'svg');
      svg.setAttribute('width', '14'); svg.setAttribute('height', '14'); svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('fill', 'none'); svg.setAttribute('stroke', 'currentColor'); svg.setAttribute('stroke-width', '2');
      svg.setAttribute('stroke-linecap', 'round'); svg.setAttribute('aria-hidden', 'true');
      const p = document.createElementNS(ns, 'path'); p.setAttribute('d', d); svg.appendChild(p);
      return svg;
    };
    const el = (tag, cl, texte) => { const e = document.createElement(tag); if (cl) e.className = cl; if (texte != null) e.textContent = texte; return e; };

    const creerLigne = (item, i) => {
      const c = colorisLigne(item);
      const pal = c && MR14.palette ? MR14.palette[c.id] : null;
      const nomCoul = c ? c.nom : (item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '');
      const ligne = el('div', 'm-ligne m-casc');
      ligne.style.setProperty('--d', (130 + i * 50) + 'ms');
      ligne.dataset.key = item.key;
      if (pal) {
        ligne.style.setProperty('--toile', pal.toile);
        ligne.style.setProperty('--toile-clair', pal.clair);
        ligne.style.setProperty('--toile-sombre', pal.sombre);
        ligne.style.setProperty('--couture', pal.couture);
        ligne.style.setProperty('--toile-bord', pal.bord);
        ligne.style.setProperty('--m-c', pal.hex);
      }
      const vign = el('span', 'm-ligne-img');
      vign.setAttribute('role', 'img');
      vign.setAttribute('aria-label', 'Illustration du hamac' + (nomCoul ? ', coloris ' + nomCoul : ''));
      if (mini && mini.content) vign.appendChild(mini.content.cloneNode(true));
      const txt = el('div', 'm-ligne-txt');
      txt.appendChild(el('span', 'm-ligne-nom', item.product_title || item.title || ''));
      if (nomCoul) txt.appendChild(el('span', 'm-ligne-coul', 'Coloris ' + nomCoul));
      const qte = el('div', 'm-qte');
      const moins = el('button'); moins.type = 'button'; moins.setAttribute('aria-label', 'Retirer un hamac'); moins.appendChild(icone('M5 12h14'));
      const plus = el('button'); plus.type = 'button'; plus.setAttribute('aria-label', 'Ajouter un hamac'); plus.appendChild(icone('M12 5v14M5 12h14'));
      moins.dataset.mQte = '-1'; plus.dataset.mQte = '1';
      const n = el('span', 'm-qte-n');
      n.appendChild(el('span', 'm-sr', 'Quantité : '));
      const nb = el('span', 'm-roule-boite'); const nbv = el('span', 'm-roule-v', String(item.quantity)); nbv.dataset.mN = ''; nb.appendChild(nbv); n.appendChild(nb);
      qte.append(moins, n, plus);
      txt.appendChild(qte);
      const prix = el('span', 'm-ligne-prix');
      const pb = el('span', 'm-roule-boite'); const pv = el('span', 'm-roule-v', MR14.prix(item.final_line_price)); pv.dataset.mP = ''; pb.appendChild(pv); prix.appendChild(pb);
      ligne.append(vign, txt, prix);
      return ligne;
    };

    const rendre = (panier, sens) => {
      if (!panier || !Array.isArray(panier.items)) return panier;
      const items = panier.items;
      const actuelles = lignesEl ? [...lignesEl.children].map((l) => l.dataset.key) : [];
      const memes = actuelles.length === items.length && items.every((it, i) => it.key === actuelles[i]);
      qtes = {};
      items.forEach((it) => { qtes[it.key] = it.quantity; });
      if (lignesEl) {
        if (memes) {
          items.forEach((it, i) => {
            const l = lignesEl.children[i];
            const nAvant = Number(l.querySelector('[data-m-n]').textContent);
            const s = sens || (it.quantity >= nAvant ? 1 : -1);
            roule(l.querySelector('[data-m-n]'), it.quantity, s);
            roule(l.querySelector('[data-m-p]'), MR14.prix(it.final_line_price), s);
          });
        } else {
          lignesEl.replaceChildren(...items.map(creerLigne));
        }
      }
      roule(totalEl, MR14.prix(panier.total_price), sens || 1);
      poserCompte(Number(panier.item_count) || 0, sens || 1);
      return panier;
    };

    const lire = () => json(URL_PANIER).then((p) => rendre(p));

    // Quantités : file d'attente pour garder l'ordre des clics
    let file = Promise.resolve();
    if (lignesEl) {
      lignesEl.addEventListener('click', (e) => {
        const b = e.target.closest('[data-m-qte]');
        if (!b) return;
        const l = b.closest('.m-ligne');
        if (!l) return;
        const key = l.dataset.key;
        const d = Number(b.dataset.mQte);
        const n = Math.max(0, (qtes[key] || 0) + d);
        if (n === qtes[key]) return;
        qtes[key] = n;
        cacherErreur();
        roule(l.querySelector('[data-m-n]'), n, d);
        file = file.then(() => json(URL_CHANGE, { id: key, quantity: n })
          .then((p) => {
            rendre(p, d);
            annoncer(p.item_count ? `Quantité : ${n}.` : 'Votre panier est vide.');
            if (!p.item_count && fermerBtn) fermerBtn.focus({ preventScroll: true });
          })
          .catch((err) => {
            montrerErreur(err.message);
            return lire().catch(() => {});
          }));
      });
    }

    /* ===================== Ouverture / fermeture du tiroir ===================== */
    let ouvert = false;
    let retour = null;
    let etape = 'repos';
    let bouton = null;
    const minuteurs = [];
    const tempo = (fn, ms) => { const id = setTimeout(fn, ms); minuteurs.push(id); return id; };
    const fond = () => [$('#contenu'), nav, barre].filter(Boolean);
    if (tiroir) tiroir.inert = true;

    const etat = (b, e) => {
      etape = e;
      if (!b) return;
      b.classList.remove(...ETATS);
      if (e !== 'repos') b.classList.add(e);
    };

    const focusFermer = () => tempo(() => { if (fermerBtn) fermerBtn.focus({ preventScroll: true }); }, 90);

    const ouvrir = (depuis) => {
      if (!tiroir || ouvert) return;
      ouvert = true;
      retour = depuis || panierBtn;
      tiroir.inert = false;
      tiroir.classList.add('m-ouvert');
      tiroir.setAttribute('aria-hidden', 'false');
      if (voile) voile.classList.add('m-ouvert');
      fond().forEach((x) => { x.inert = true; });
      focusFermer();
    };

    const fermer = () => {
      if (!tiroir || !ouvert) return;
      ouvert = false;
      tiroir.classList.remove('m-ouvert');
      tiroir.setAttribute('aria-hidden', 'true');
      tiroir.inert = true;
      if (voile) voile.classList.remove('m-ouvert');
      fond().forEach((x) => { x.inert = false; });
      if (barre) barre.inert = !barreVue;
      if (etape === 'fini') {
        const b = bouton;
        tempo(() => { etat(b, 'repos'); bouton = null; majBoutons(); }, 460);
      }
      const r = retour;
      retour = null;
      if (r && r.focus && document.contains(r)) r.focus({ preventScroll: true });
    };

    if (panierBtn) panierBtn.addEventListener('click', (e) => { e.preventDefault(); ouvrir(panierBtn); });
    if (voile) voile.addEventListener('click', fermer);
    if (fermerBtn) fermerBtn.addEventListener('click', fermer);
    if (tiroir) tiroir.addEventListener('keydown', (e) => { if (e.key === 'Escape') { e.stopPropagation(); fermer(); } });
    const versProduit = $('[data-m-vers-produit]');
    if (versProduit) versProduit.addEventListener('click', () => fermer());

    /* ===================== La goutte ===================== */
    const trajet = (o) => {
      const { bx, by, x0, y0, cx, cy, x1, y1, sat } = o;
      const pt = (t) => { const u = 1 - t; return [u * u * x0 + 2 * u * t * cx + t * t * x1, u * u * y0 + 2 * u * t * cy + t * t * y1]; };
      const tan = (t) => Math.atan2(2 * (1 - t) * (cy - y0) + 2 * t * (y1 - cy), 2 * (1 - t) * (cx - x0) + 2 * t * (x1 - cx)) * 180 / Math.PI;
      const tr = (x, y, a, sx, sy) => `translate(${x.toFixed(1)}px, ${y.toFixed(1)}px) rotate(${a.toFixed(1)}deg) scale(${sx.toFixed(3)}, ${sy.toFixed(3)})`;
      const a0 = tan(0);
      let prev = a0;
      const k = [];
      const debut = sat ? 0 : 0.2;
      if (!sat) {
        // naissance : la goutte sort écrasée du bouton puis s'étire vers le haut
        k.push({ offset: 0, opacity: 0, transform: tr(bx, by, a0, 0.3, 1.5) });
        k.push({ offset: 0.07, opacity: 1, transform: tr(bx, by - 6, a0, 0.34, 1.7) });
        k.push({ offset: 0.2, opacity: 1, transform: tr(x0, y0, a0, 1.38, 0.76) });
      } else {
        k.push({ offset: 0, opacity: 0, transform: tr(x0, y0, a0, 0.6, 0.6) });
      }
      const N = 22;
      for (let i = 1; i <= N; i++) {
        const s = i / N;
        const t = 0.45 * s + 0.55 * s * s * (3 - 2 * s);
        const [x, y] = pt(t);
        let a = tan(t);
        while (a - prev > 180) a -= 360;
        while (a - prev < -180) a += 360;
        prev = a;
        const st = 1 + 0.3 * Math.sin(Math.PI * s);
        const sc = sat ? 1 - 0.3 * s : 1 - 0.58 * s * s;
        let op = 1;
        if (sat) op = s < 0.12 ? s / 0.12 : (s < 0.55 ? 1 : Math.max(0, 1 - (s - 0.55) / 0.3));
        else if (i === N) op = 0;
        k.push({ offset: debut + (1 - debut) * s, opacity: op, transform: tr(x, y, a, sc * st, sc / st) });
      }
      return k;
    };

    let vols = [];
    const vol = (b, c) => {
      const bx = b.left + b.width / 2;
      const by = b.top + b.height / 2;
      const x0 = bx;
      const y0 = b.top - 8;
      const x1 = c.left + c.width / 2;
      const y1 = c.top + c.height / 2;
      const cx = x0 + (x1 - x0) * 0.32;
      const cy = Math.max(-20, Math.min(y0, y1) - Math.max(110, Math.abs(x1 - x0) * 0.22));
      const base = { bx, by, x0, y0, cx, cy, x1, y1 };
      vols = [];
      if (goutte && goutte.animate) vols.push(goutte.animate(trajet({ ...base, sat: false }), { duration: 820, easing: 'linear' }));
      [[s1, 70, 18], [s2, 120, -24], [s3, 165, 32]].forEach(([g, d, j]) => {
        if (g && g.animate) vols.push(g.animate(trajet({ ...base, cx: cx + j, cy: cy + Math.abs(j) * 0.6, sat: true }), { duration: 600, delay: 165 + d, easing: 'linear', fill: 'backwards' }));
      });
    };

    // Arrivée : panier « gelée » + éclat, compteur et tiroir mis à jour depuis le vrai panier
    const arrivee = (panier) => {
      rendre(panier, 1);
      const n = Number(panier.item_count) || 0;
      annoncer(`Hamac de fenêtre ajouté au panier. ${n} article${n > 1 ? 's' : ''}.`);
      if (reduit || !panierBtn || !panierBtn.animate) return;
      panierBtn.animate([
        { transform: 'scale(1)' },
        { transform: 'scale(1.3, .74)', offset: 0.2 },
        { transform: 'scale(.84, 1.18)', offset: 0.44 },
        { transform: 'scale(1.07, .94)', offset: 0.66 },
        { transform: 'scale(.98, 1.02)', offset: 0.84 },
        { transform: 'scale(1)' },
      ], { duration: 700, easing: 'ease-out' });
      if (eclat && eclat.animate) {
        const r = panierBtn.getBoundingClientRect();
        const x = r.left + r.width / 2;
        const y = r.top + r.height / 2;
        eclat.animate([
          { transform: `translate(${x}px, ${y}px) scale(.5)`, opacity: 0.95 },
          { transform: `translate(${x}px, ${y}px) scale(2.4)`, opacity: 0 },
        ], { duration: 640, easing: 'cubic-bezier(.23,1,.32,1)' });
      }
    };

    /* ===================== Ajout au panier ===================== */
    const ajouter = (btn) => {
      if (!btn || btn.disabled || etape !== 'repos') return;
      const variante = typeof MR14.variante === 'function' ? MR14.variante() : null;
      if (!variante) return;
      cacherErreur();
      bouton = btn;
      // la requête part tout de suite, puis on relit le panier complet
      const requete = json(URL_AJOUT, { items: [{ id: Number(variante), quantity: 1 }] }).then(() => json(URL_PANIER));
      const animable = !reduit && panierBtn && goutte && typeof goutte.animate === 'function' && panierBtn.getClientRects().length > 0;

      const echec = (err) => {
        minuteurs.splice(0).forEach(clearTimeout);
        vols.forEach((a) => { try { a.cancel(); } catch (e) { /* rien */ } });
        vols = [];
        etat(btn, 'repos');
        bouton = null;
        majBoutons();
        montrerErreur(err && err.message);
        lire().catch(() => {});
      };

      if (!animable) {
        etat(btn, 'appui');
        requete.then((p) => {
          arrivee(p);
          etat(btn, 'fini');
          ouvrir(btn);
        }, echec);
        return;
      }

      const b = btn.getBoundingClientRect();
      const c = panierBtn.getBoundingClientRect();
      let rate = false;
      etat(btn, 'appui');
      tempo(() => { if (!rate) { etat(btn, 'vole'); vol(b, c); } }, 170);
      const atterrit = new Promise((ok) => tempo(ok, 170 + 820));
      requete.catch((err) => { rate = true; echec(err); });
      Promise.all([requete, atterrit]).then(([p]) => {
        etat(btn, 'pose');
        arrivee(p);
        tempo(() => { etat(btn, 'fini'); ouvrir(btn); }, 450);
      }, () => {});
    };

    document.addEventListener('click', (e) => {
      const b = e.target.closest && e.target.closest('[data-mr14-ajouter]');
      if (!b) return;
      e.preventDefault();
      ajouter(b);
    });

    MR14.panier = { ajouter, ouvrir: () => ouvrir(document.activeElement !== document.body ? document.activeElement : panierBtn), fermer, lire };

    /* ===================== Chargement ===================== */
    lire().catch(() => {});
    addEventListener('pageshow', (e) => { if (e.persisted) lire().catch(() => {}); });
  });
})();
